export const adaptGrupoProfesional = (grupoProfesionalData) => {
    return {
        id: grupoProfesionalData?.idGrupoProfesional,
        displayName: grupoProfesionalData?.nombre,
        name: grupoProfesionalData?.nombre
    }
}

export const adaptGrupoProfesionalArray = (
    grupoProfesionales
) => {
    return structuredClone(grupoProfesionales?.allGrupoProfesional)
        ?.map(grupoProfesional => adaptGrupoProfesional(grupoProfesional));
}